module.exports = __webpack_public_path__ + "img/DefaultO.913d7660.png";